/*eslint-disable*/
import api from '../'

class chainsGameItems {
    // POST: chain
    static getChainByRequest (params) {
        return api.axios.post('/chainByRequest', params).then(response => response.data.chain);
    }
}

export default chainsGameItems;
